// extracted by mini-css-extract-plugin
module.exports = {"related":"Related_related__1Ty6g","title":"Related_title__1wYkT"};